import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=91e1e138&v-on-clickaway=cancel&"
import script from "./CreateProfile.vue?vue&type=script&lang=ts&"
export * from "./CreateProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports